import { createSelector } from 'reselect'
import { sum, uniqueBy } from 'lib/array/arrayUtils'
import { getCheckoutCruiseOfferView } from 'checkout/selectors/view/cruise'

export const getAvailableCruiseBenefits = createSelector(
  (state: App.State) => getCheckoutCruiseOfferView(state),
  (state: App.State) => state.luxPlus.products.subscription,
  (cruiseOfferView, productSubscription): App.Checkout.LuxPlusCruiseBenefits => {
    const cruiseViews = cruiseOfferView.data.flatMap<App.Checkout.CruiseAccommodationItemView>(view => {
      return view.itemViews.filter(itemView => itemView.kind === 'cruise')
    })

    let totalPrice = 0
    if (cruiseViews.length > 0) {
      totalPrice = sum(cruiseViews, view => view.cabinRate?.priceDetails.price ?? 0)
    }

    const offersWithJoinFeeWaived = productSubscription?.offers?.filter(offer => offer.joinFeeWaived)

    let hasLuxPlusInclusions = false
    const subscriptionViews = offersWithJoinFeeWaived?.map<App.Checkout.LuxPlusCheckoutBenefitsSubscriptionViewWithInclusions>(offer => {
      const inclusions = cruiseViews.flatMap(view => {
        const luxPlusInclusions = view.item?.luxPlusInclusionsByTier?.[offer.tier] ?? []
        return luxPlusInclusions
      })

      if (inclusions.length) {
        hasLuxPlusInclusions = true
      }

      return {
        inclusions: uniqueBy(inclusions, incl => incl.description),
        offer,
      }
    }) ?? []

    return {
      inclusions: subscriptionViews.flatMap(view => view.inclusions) ?? [],
      subscriptionViews,
      hasLuxPlusInclusions,
      totalPrice,
      totalMemberPrice: 0,
      totalBaseMemberPrice: 0,
      totalMemberPriceSavings: 0,
    }
  })
